import React from 'react';
import ReviewLayout from '../Templates/ReviewLayout';

const FirstApproverTeam = () => {
    const verticalMenuItems = [
        { key: '1', title: 'ACE - Individual Awards', path: '/review/level1/individual' },
        { key: '2', title: 'ACE - Team Awards', path: '/review/level1/team' },
    ];

    return (
        <ReviewLayout
            subtitle="First Level Review"
            stage="4"
            stageName="Team Award Nominees"
            verticalMenuItems={verticalMenuItems}
            currentStage={2}
        />
    );
};

export default FirstApproverTeam;
